module.exports = __webpack_public_path__ + "img/ic-masterCard-white.d4668926.svg";